import { render } from "./FilterChipBasic.vue?vue&type=template&id=ac7639fe"
import script from "./FilterChipBasic.vue?vue&type=script&lang=js"
export * from "./FilterChipBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__